import { ExerciseGameType } from '@/api/common';
import Exercise from '@/api/exercise';
import Lesson from '@/api/lesson';
import Module from '@/api/module';
import EntityView from '@/views/EntityView.vue';
import ProjectView from '@/views/ProjectView.vue';
import LessonView from '@/views/LessonView.vue';
import ExerciseView from '@/views/ExerciseView.vue';
import Submodule from '@/api/submodule';
import Project from '@/api/project';

export const MODULE_ROUTE = [
  {
    path: `/${Project.SLUG}/`,
    name: `${Project.SLUG}-list`,
    component: ProjectView,
    props: () => ({
      entity: Project.SLUG
    }),
    meta: {
      title: 'Project · ELSA Content Creator'
    }
  },
  {
    path: `/${Project.SLUG}/new`,
    name: `${Project.SLUG}-new`,
    component: EntityView,
    props: () => ({
      entity: Project.SLUG,
      isNew: true,
      isEdit: true
    }),
    meta: {
      title: 'New Project · ELSA Content Creator'
    }
  },
  {
    path: `/${Project.SLUG}/:id(\\d+)`,
    name: `${Project.SLUG}-edit`,
    component: EntityView,
    props: (route) => ({
      entity: Project.SLUG,
      id: parseInt(route.params.id, 10),
      isEdit: true
    }),
    meta: {
      title: 'Edit Project · ELSA Content Creator'
    }
  },
  {
    path: `/${Module.SLUG}/`,
    name: `${Module.SLUG}-list`,
    component: EntityView,
    props: () => ({
      entity: Module.SLUG
    }),
    meta: {
      title: 'Modules · ELSA Content Creator'
    }
  },
  {
    path: `/${Module.SLUG}/new`,
    name: `${Module.SLUG}-new`,
    component: EntityView,
    props: () => ({
      entity: Module.SLUG,
      isNew: true,
      isEdit: true
    }),

    meta: {
      title: 'New Module · ELSA Content Creator'
    }
  },
  {
    path: `/${Module.SLUG}/:id(\\d+)`,
    name: `${Module.SLUG}-edit`,
    component: EntityView,
    props: (route) => ({
      entity: Module.SLUG,
      id: parseInt(route.params.id, 10),
      isEdit: true
    }),
    meta: {
      title: 'Edit Module · ELSA Content Creator'
    }
  },
  {
    path: `/${Module.SLUG}/:id(\\d+)/${Lesson.SLUG}`,
    name: `${Lesson.SLUG}-list`,
    component: LessonView,
    props: (route) => ({
      entity: Lesson.SLUG,
      moduleId: parseInt(route.params.id, 10)
    }),
    meta: {
      title: 'Lessons · ELSA Content Creator'
    }
  },
  {
    path: `/${Module.SLUG}/:moduleId(\\d+)/${Lesson.SLUG}/:lessonId(\\d+)`,
    name: `${Lesson.SLUG}-edit`,
    component: LessonView,
    props: (route) => ({
      entity: Lesson.SLUG,
      moduleId: parseInt(route.params.moduleId, 10),
      id: parseInt(route.params.lessonId, 10),
      isEdit: true
    }),
    meta: {
      title: 'Edit Lesson · ELSA Content Creator'
    }
  },
  {
    path: `/${Module.SLUG}/:id(\\d+)/${Lesson.SLUG}/new`,
    name: `${Lesson.SLUG}-new`,
    component: LessonView,
    props: (route) => ({
      entity: Lesson.SLUG,
      moduleId: parseInt(route.params.id, 10),
      isNew: true,
      isEdit: true
    }),
    meta: {
      title: 'New Lesson · ELSA Content Creator'
    }
  },
  {
    path: `/${Module.SLUG}/:moduleId(\\d+)/${Lesson.SLUG}/:lessonId(\\d+)/${Exercise.SLUG}`,
    name: `${Exercise.SLUG}-list`,
    component: ExerciseView,
    props: (route) => ({
      moduleId: parseInt(route.params.moduleId, 10),
      lessonId: parseInt(route.params.lessonId, 10),
      isModule: true
    }),
    meta: {
      title: 'Exercises · ELSA Content Creator'
    }
  },
  {
    path: `/${Module.SLUG}/:moduleId(\\d+)/${
      Lesson.SLUG
    }/:lessonId(\\d+)/:gametype(${ExerciseGameType.regex()})`,
    name: `${Exercise.SLUG}-new`,
    component: ExerciseView,
    props: (route) => ({
      moduleId: parseInt(route.params.moduleId, 10),
      lessonId: parseInt(route.params.lessonId, 10),
      gameType: ExerciseGameType.slugToType(route.params.gametype),
      isNew: true,
      isEdit: true,
      isModule: true
    }),
    meta: {
      title: 'New Exercise · ELSA Content Creator'
    }
  },
  {
    path: `/${Module.SLUG}/:moduleId(\\d+)/${
      Lesson.SLUG
    }/:lessonId(\\d+)/:gametype(${ExerciseGameType.regex()})/:exerciseId(\\d+)`,
    name: `${Exercise.SLUG}-edit`,
    component: ExerciseView,
    props: (route) => ({
      moduleId: parseInt(route.params.moduleId, 10),
      lessonId: parseInt(route.params.lessonId, 10),
      id: parseInt(route.params.exerciseId, 10),
      gameType: ExerciseGameType.slugToType(route.params.gametype),
      isEdit: true,
      isModule: true
    }),
    meta: {
      title: 'Edit Exercise · ELSA Content Creator'
    }
  },
  {
    path: `/${Module.SLUG}/:moduleId(\\d+)/${Submodule.SLUG}/:id(\\d+)`,
    name: `${Submodule.SLUG}-edit`,
    component: LessonView,
    props: (route) => ({
      entity: Submodule.SLUG,
      moduleId: parseInt(route.params.moduleId, 10),
      id: parseInt(route.params.id, 10),
      isEdit: true
    }),
    meta: {
      title: 'Edit Submodule · ELSA Content Creator'
    }
  },
  {
    path: `/${Module.SLUG}/:id(\\d+)/${Submodule.SLUG}/new`,
    name: `${Submodule.SLUG}-new`,
    component: LessonView,
    props: (route) => ({
      entity: Submodule.SLUG,
      moduleId: parseInt(route.params.id, 10),
      isNew: true,
      isEdit: true
    }),
    meta: {
      title: 'New Submodule · ELSA Content Creator'
    }
  }
];
